import React, { PropsWithChildren } from 'react';

import { FlowModel } from '@/models/flow.model';

import { OnboardingProgress } from '../OnboardingProgress';

import { styles } from './MainModal.styles';
import { MainModalLayoutProvider, useMainModalLayout } from './MainModalLayoutContext';

type MainModalProps = PropsWithChildren<{
  flow: FlowModel;
  disableScroll?: boolean;

}>;

/** Renders the compact-actions footer mount node; must stay under {@link MainModalLayoutProvider}. */
export const MainModalFooterMount: React.FC = () => {
  const layout = useMainModalLayout();

  if (!layout) {
    throw new Error('MainModalFooterMount must be used within MainModalLayoutProvider');
  }

  const { setFooterMount } = layout;

  return (
    <div
      ref={ setFooterMount }
      css={ styles.Footer }
      className="main-modal-footer"
      data-testid="main-modal-footer-mount"
    />
  );
};

const MainModalInner: React.FC<MainModalProps> = ({ children, flow, disableScroll = false }) => (
  <div css={ styles.Root } className="main-modal" data-testid="main-modal-root">
    <OnboardingProgress
      className="main-modal-header"
      steps={ flow.getSteps() }
      css={ styles.Header }
      flow={ flow }
    />
    <div
      css={ styles.Content(!disableScroll) }
      className="main-modal-body"
      id="onboarding-scroll-container"
    >
      { children }
    </div>
    <MainModalFooterMount />
  </div>
);

const MainModal: React.FC<MainModalProps> = (props) => (
  <MainModalLayoutProvider>
    <MainModalInner { ...props } />
  </MainModalLayoutProvider>
);

export default MainModal;
